/**
 * 问题的配置结构
 */
export interface Question {
  // 问题的代号
  code: string;

  // 问题详细内容, 内容里面可能会涉及到变量，使用 `{}` 标注变量
  label: string;

  // 指向的下一个问题的 code，如果为空，则代表为最后一个问题
  next?: string;

  // 是否可以多选
  multiple?: boolean;

  // 问题的注释（访员提示）
  notes?: string;

  // 问题有的选项
  choices: Choice[];

  /**
   * 循环相关配置
   */
  // 是否存在需要循环的问题
  loop?: boolean;
  // 循环依据， choice_count: 根据选项数量进行循环， choice_value: 根据选项的数值进行循环，要求选项必须是number_input
  loop_type?: "choice_count" | "choice_value";
  // 最大循环次数
  loop_max?: number;
  // 循环问题
  sub_questions?: Question[];

  // 该问题的规则
  rules?: Array<Record<string, string>>;

  // 需要在循环前插入的问题
  before_loop_questions?: Question[];
}

export enum RuleType {
  // 标识跳过该题
  SKIP = "skip",

  // 仅在这个条件下触发
  ONLY = "only",
}

/**
 * 选项的配置结构
 */
export interface Choice {
  // 选项的代号
  code: string;

  // 选项的表单类型
  type: ChoiceType;

  // 选项文本，type = “PLAIN_TEXT” 时， 必须
  label?: string;

  // 针对不同表单类型，额外的配置
  config?:
    | PlainTextConfig
    | AddressInputConfig
    | NumberInputConfig
    | DateInputConfig
    | OtherInputConfig
    | InputConfig;

  // 选项可触发的下一个问题，设置为 "_QUIT" 时结束问卷
  next?: string | "_QUIT";

  // 初始状态下选中
  default_selected?: boolean;

  // 选择该选项之后，其他选项都取消勾选
  conflict?: boolean;

  escape_loop?: boolean;
}

/**
 * 纯文本配置项
 */
export interface PlainTextConfig {
  prefix?: string;
  suffix?: string;
  value?: any; // 覆盖文本value
}
/**
 * 地址输入配置项
 */
export interface AddressInputConfig {
  // 是否显示省级输入框
  province?: boolean;
  // 是否显示市级输入框
  city?: boolean;
  // 是否显示县级输入框
  county?: boolean;
  // 是否显示街道输入框
  street?: boolean;

  // 启用额外的输入
  address_plus?: {
    label: string;
    input_type: "text" | "int" | "double";
  };
}
/**
 * 数字输入配置项
 */
export interface NumberInputConfig {
  type: "int" | "double";
  min?: number;
  max?: number;
  prefix?: string;
  suffix?: string;
  limit_rule?: NumInLimitRuleDSL; // 动态的限制规则列表，用 AND 拼接
}
export interface NumInLimitRuleDSL {
  and?: Array<NumInLimitRuleDSL>;
  or?: Array<NumInLimitRuleDSL>;
  rule?: any;
}
/**
 * 日期输入配置项
 */
export interface DateInputConfig {
  level: "year" | "month" | "date";

  year_min?: number;
  year_max?: number;
}
/**
 * 其他输入配置项
 */
export interface OtherInputConfig {
  // 显示输入框还是多行输入
  // type?: "input" | "textarea";
  // 提示的文本（通常是 其他 ）
  label?: string;
}

export interface InputConfig {
  input_type: "textarea" | "input";
}

/**
 * 选项的表单类型
 */
export enum ChoiceType {
  // 预设的纯文本
  PLAIN_TEXT = "PLAIN_TEXT",

  // 可自定义输入的纯文本
  INPUT = "INPUT",

  // 地址输入
  ADDRESS_INPUT = "ADDRESS_INPUT",

  // 数字输入
  NUMBER_INPUT = "NUMBER_INPUT",

  // 日期输入
  DATE_INPUT = "DATE_INPUT",

  // 其他输入
  OTHER_INPUT = "OTHER_INPUT",

  // 时间输入 + 数量
  TIME_NUMBER = "TIME_NUMBER",
}
